
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import TitlePage from '@/components/atoms/TitlePage.vue'
import TextFrame from '@/components/atoms/TextFrame.vue'
import LabelBase from '@/components/atoms/LabelBase.vue'
import InputPassword from '@/components/molecules/InputPassword.vue'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'

/**
 * パスワード再設定ページのフォーマット
 */
@Component({
  components: {
    ImageBase,
    TitlePage,
    TextFrame,
    LabelBase,
    InputPassword,
    ButtonSubmit,
    PanelFrame,
  },
})
export default class PasswordReset extends Vue {
  /** 送信ボタン押下時のイベント */
  @Prop()
  private eventSubmit!: (password: string, confirmPassword: string) => Promise<void>

  /** 新しいパスワード */
  private password: string = ''

  /** 新しいパスワード(確認用) */
  private confirmPassword: string = ''

  /**
   * 入力チェック
   *
   * @returns 未入力の場合は送信ボタンを無効化
   */
  private get isBlanked(): boolean {
    return this.password === '' || this.confirmPassword === ''
  }

  /**
   * 送信ボタン押下時処理
   */
  private async submit(): Promise<void> {
    await this.eventSubmit(this.password, this.confirmPassword)
  }
}
